import React, { createContext, useContext, useEffect, useState } from "react";

interface Ctx {
  projectId: number | null;
  setProjectId: (id: number | null) => void;
}

const ProjectContext = createContext<Ctx>({
  projectId: null,
  setProjectId: () => {},
});

const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX || "hsp.";
const STORAGE_KEY = `${STORAGE_PREFIX}selectedProjectId`;

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [projectId, setProjectIdState] = useState<number | null>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? Number(stored) : null;
  });

  const setProjectId = (id: number | null) => {
    setProjectIdState(id);
    if (id == null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, String(id));
  };

  useEffect(() => {
    // Sync if changed elsewhere (e.g. another tab)
    const handler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setProjectIdState(e.newValue ? Number(e.newValue) : null);
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <ProjectContext.Provider value={{ projectId, setProjectId }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = () => useContext(ProjectContext);
